import { Injectable } from '@angular/core';
import { CachedCRUDService } from '../types/cached-c-r-u-d.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServerResponse } from '../types/http.interfaces';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TableKeyItemWithCode } from '../types/table';

@Injectable({
  providedIn: 'root',
})
export class DocumentTypeService extends CachedCRUDService<DocumentType, never, never> {
  constructor(private http: HttpClient) {
    super();
    this.options.cacheExpiration = -1;
  }

  protected override async _fetchNewData(): Promise<DocumentType[]> {
    const headers = new HttpHeaders({ skip: 'skip' });

    const res: ServerResponse<DocumentType[]> = await lastValueFrom(
      this.http.get<ServerResponse<DocumentType[]>>(
        `${environment.api}/actors-ms/api/v1/documentTypes`,
        { headers }
      )
    );
    return res.data;
  }
  protected override async _getByIdData(id: number): Promise<DocumentType | undefined> {
    const res: ServerResponse<DocumentType> = await lastValueFrom(
      this.http.get<ServerResponse<DocumentType>>(
        `${environment.api}/actors-ms/api/v1/documentTypes/${id}`
      )
    );
    return res.data;
  }
}

export interface DocumentType {
  id: number;
  description: string;
  code: string;
  createdAt: Date;
  updatedAt: Date;
}
